import { loader } from "graphql.macro";
import { gql } from "@apollo/client";
const schema = loader("./schema.graphql");

export const typeDefs = gql`
  ${schema}
`;

export default typeDefs;
